import type { ChargeType } from '../services/api/types.gen';

// Charge/unit basis labels shared by the insurance modal and the per-visit
// rates editor. CONSTANT (a fixed unit count) is valid on rate rows but not
// as an insurance-level charge type, so the two option lists differ.

export const CHARGE_TYPE_LABELS: Record<ChargeType, string> = {
  VISIT: 'Per visit',
  HOURLY: 'Hourly',
  FIFTEEN_MINUTE: '15 min',
  CONSTANT: 'Constant',
};

// Insurance-level charge type (the backend rejects CONSTANT here).
export const INSURANCE_CHARGE_TYPE_OPTIONS: {
  value: ChargeType;
  label: string;
}[] = [
  { value: 'VISIT', label: 'Per visit' },
  { value: 'HOURLY', label: 'Hourly' },
  { value: 'FIFTEEN_MINUTE', label: '15-minute increment' },
];

// Per-visit rate row charge/allowed bases. CONSTANT is deliberately absent:
// it is a claim-units concept only — the WellSky sync never emits it for
// charge_by/allowed_by and the backend rejects it there with a 422.
export const RATE_CHARGE_BASIS_OPTIONS: {
  value: ChargeType;
  label: string;
}[] = [
  { value: 'VISIT', label: CHARGE_TYPE_LABELS.VISIT },
  { value: 'HOURLY', label: CHARGE_TYPE_LABELS.HOURLY },
  { value: 'FIFTEEN_MINUTE', label: CHARGE_TYPE_LABELS.FIFTEEN_MINUTE },
];

// Claim-units basis: the full enum. CONSTANT (a fixed unit count per claim
// line) is valid here and pairs with the constant-units input.
export const CLAIM_UNITS_BASIS_OPTIONS: {
  value: ChargeType;
  label: string;
}[] = (Object.entries(CHARGE_TYPE_LABELS) as [ChargeType, string][]).map(
  ([value, label]) => ({ value, label })
);

export const BILLING_FREQUENCY_OPTIONS: { value: string; label: string }[] = [
  { value: 'MONTHLY', label: 'Monthly' },
  { value: 'WEEKLY', label: 'Weekly' },
  { value: 'SEMIMONTHLY', label: 'Semi-monthly' },
  { value: 'EPISODIC', label: 'Episodic' },
];
